import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { ThemePickerComponent } from '../theme-picker/theme-picker.component';
import { LogoComponent } from '../logo/logo.component';
import { MenuModule } from 'primeng/menu';
import { IconComponent } from '../icon/icon.component';
import { AccountService, ProfileService } from '@doddly/core';

@Component({
  selector: 'ly-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    AvatarModule,
    ButtonModule,
    MenuModule,
    LogoComponent,
    ThemePickerComponent,
    IconComponent,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  profileService = inject(ProfileService);
  profile = computed(() => this.profileService.getProfile());
  accountService = inject(AccountService);

  showSupport = input(false);

  menuItems = computed(() => [
    {
      ...(this.profileDisplayName ? { label: this.profileDisplayName } : {}),
      icon: 'user',
      styleClass: 'profile-header-item',
    },
    {
      separator: true,
    },
    {
      label: 'Profile',
      icon: 'user',
      url: '/profile',
    },
    ...(this.showSupport()
      ? [
          {
            label: 'Support',
            icon: 'notifications',
            url: `/dashboard/account/${this.accountService.activeAccount().id}/support`,
          },
        ]
      : []),

    {
      label: 'Logout',
      icon: 'expandClose',
      url: '/sign-out',
    },
  ]);

  get profileDisplayName(): string | null {
    if (this.profile().firstName || this.profile().lastName) {
      return `${this.profile().firstName} ${this.profile().lastName}`;
    }
    return this.profile().displayName;
  }

  get profileAvatarURL() {
    return this.profile().avatarURL;
  }

  get profileEmail(): string {
    return this.profile().email;
  }
}
